export const isDesktopApp = (): boolean => typeof window !== 'undefined' && 'desktopAPI' in window;
